import { DataSourceMode, Layout, EditRowDecorator, LookupModelSelectionEvent, LookupModelSearchEvent, DropdownSelectionEvent, DataSourceExecutionEvent, DataDisplayEvent } from "@mcleod/components";
import { ModelRow } from "@mcleod/core";
import { AutogenLayoutMarketingPlanDetail } from "./autogen/AutogenLayoutMarketingPlanDetail";
import { EditRowDecoratorProps } from "@mcleod/components/src/page/decorators/EditRowDecoratorProps";

export class MarketingPlanDetail extends AutogenLayoutMarketingPlanDetail {

    static showAdd(props:Partial<EditRowDecoratorProps>) {
        const layout = Layout.getLayout('lme/crm/MarketingPlanDetail') as MarketingPlanDetail;
        const erd = new EditRowDecorator({
            layout: layout,
            title: 'Add Marketing Plan Activity',
            overlayProps: { closeOnClickOff: false, greyedBackground: true },
            layoutLoadListeners: [async (event)=> {
                const layout = event.target as MarketingPlanDetail;
                const newRow = await layout.mainDataSource.createBlankRow();
                erd.data = newRow;
                layout.mainDataSource.setRowsAndMode(DataSourceMode.ADD, [newRow]);
            }],
            ...props
        });
    }

    textboxCodeBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.type_of = "C";
        event.filter.id = "!RECCALL";
    }

    textboxCodeOnLookupModelSelection(event: LookupModelSelectionEvent) {
        if (event.hasSelection()) {
            const selectedRow = event.selection as ModelRow;
            this.activeRow.set("descr", selectedRow.get("descr"));
        }
    }

    textboxDefAssignAfterDropdownSelection(event: DropdownSelectionEvent) {
        this.textboxAssignedUserId.visible = event.hasSelection() && event.selection.value === "U";
    }

    textboxDefAssignOnDataDisplay(event: DataDisplayEvent) {
       this.textboxAssignedUserId.visible = event.rowData?.get("def_assign") === "U";
    }

    textboxAssignedUserIdBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.web_user_type = "U || E";
    }
}